export const txtStakingPanelsSectionTitle = "My Staking";
export const txtActionNameSelectAll = "Select All";
export const txtTotalNftsSelected = " selected";
export const txtActionNameStakeSelected = "Stake Selected";
export const txtActionNameUnstakeSelected = "Unstake Selected";

export enum StakingPanelType {
    UNSTAKED = "Unstaked Eternal Vikings",
    STAKED = "Staked Eternal Vikings"
}